import IAction from "../store/IAction"
import InitState from "../store/initState"
import IAddressVm from "../models/shared/IAddressVm"
import { Dispatch } from "redux"
import IPostalCodeVm from "../models/shared/IPostalCodeVm"
import ICountryVm from "../models/shared/ICountryVm"

const UPDATE_BUILDING_NAME = "BAT2/address/UPDATE_BUILDING_NAME"
const UPDATE_BUILDING_NUMBER = "BAT2/address/UPDATE_BUILDING_NUMBER"
const UPDATE_CITY_NAME = "BAT2/address/UPDATE_CITY_NAME"
const UPDATE_COMBINED_STREET_ADDRESS_LINE = "BAT2/address/UPDATE_COMBINED_STREET_ADDRESS_LINE"
const UPDATE_COUNTRY_CODE = "BAT2/address/UPDATE_COUNTRY_CODE"
const UPDATE_COUNTRY_NAME = "BAT2/address/UPDATE_COUNTRY_NAME"
const UPDATE_CO_NAME = "BAT2/address/UPDATE_CO_NAME"
const UPDATE_FLOOR = "BAT2/address/UPDATE_FLOOR"
const UPDATE_HOUSE_LETTER_FROM = "BAT2/address/UPDATE_HOUSE_LETTER_FROM"
const UPDATE_HOUSE_LETTER_TO = "BAT2/address/UPDATE_HOUSE_LETTER_TO"
const UPDATE_HOUSE_NUMBER_FROM = "BAT2/address/UPDATE_HOUSE_NUMBER_FROM"
const UPDATE_HOUSE_NUMBER_TO = "BAT2/address/UPDATE_HOUSE_NUMBER_TO"
const UPDATE_IS_FOREIGN_ADDRESS = "BAT2/address/UPDATE_IS_FOREIGN_ADDRESS"
const UPDATE_MUNICIPALITY_CODE = "BAT2/address/UPDATE_MUNICIPALITY_CODE"
const UPDATE_POSTAL_CODE = "BAT2/address/UPDATE_POSTAL_CODE"
const UPDATE_POSTAL_DISTRICT = "BAT2/address/UPDATE_POSTAL_DISTRICT"
const UPDATE_POSTBOX = "BAT2/address/UPDATE_POSTBOX"
const UPDATE_SIDE_DOOR = "BAT2/address/UPDATE_SIDE_DOOR"
const UPDATE_STREET_NAME = "BAT2/address/UPDATE_STREET_NAME"

export default function addressReducer(state: IAddressVm = {} as IAddressVm, action: IAction): IAddressVm {
    if (state === null) {
        return state
    }
    if (state.id !== action.id) {
        return state
    }
    switch (action.type) {
        case UPDATE_BUILDING_NAME:
            return { ...state, buildingName: action.payload }
        case UPDATE_BUILDING_NUMBER:
            return { ...state, buildingNumber: action.payload }
        case UPDATE_CITY_NAME:
            return { ...state, cityName: action.payload }
        case UPDATE_COMBINED_STREET_ADDRESS_LINE:
            return { ...state, combinedStreetAddressLine: action.payload }
        case UPDATE_COUNTRY_CODE:
            return { ...state, countryCode: action.payload }
        case UPDATE_COUNTRY_NAME:
            return { ...state, countryName: action.payload }
        case UPDATE_CO_NAME:
            return { ...state, coName: action.payload }
        case UPDATE_FLOOR:
            return { ...state, floor: action.payload }
        case UPDATE_HOUSE_LETTER_FROM:
            return { ...state, houseLetterFrom: action.payload }
        case UPDATE_HOUSE_LETTER_TO:
            return { ...state, houseLetterTo: action.payload }
        case UPDATE_HOUSE_NUMBER_FROM:
            return { ...state, houseNumberFrom: action.payload }
        case UPDATE_HOUSE_NUMBER_TO:
            return { ...state, houseNumberTo: action.payload }
        case UPDATE_IS_FOREIGN_ADDRESS:
            return { ...state, isForeignAddress: action.payload }
        case UPDATE_MUNICIPALITY_CODE:
            return { ...state, municipalityCode: action.payload }
        case UPDATE_POSTAL_CODE:
            return { ...state, postalCode: action.payload }
        case UPDATE_POSTAL_DISTRICT:
            return { ...state, postalDistrict: action.payload }
        case UPDATE_POSTBOX:
            return { ...state, postbox: action.payload }
        case UPDATE_SIDE_DOOR:
            return { ...state, sideDoor: action.payload }
        case UPDATE_STREET_NAME:
            return { ...state, streetName: action.payload }
        default:
            return state
    }
}
export function updateBuildingName(buildingName: string, id: string) {
    return { type: UPDATE_BUILDING_NAME, payload: buildingName, id }
}
export function updateBuildingNumber(buildingNumber: string, id: string) {
    return { type: UPDATE_BUILDING_NUMBER, payload: buildingNumber, id }
}
export function updateCityName(cityName: string, id: string) {
    return { type: UPDATE_CITY_NAME, payload: cityName, id }
}
export function updateCombinedStreetAddressLine(combinedStreetAddressLine: string, id: string) {
    return { type: UPDATE_COMBINED_STREET_ADDRESS_LINE, payload: combinedStreetAddressLine, id }
}
export function updateCoName(coName: string, id: string) {
    return async (dispatch: Dispatch<any>) => {
        const pattern: string = "C/O";

        // Check if the input already starts with "C/O"
        if (!coName.trim().toLowerCase().startsWith(pattern.toLowerCase())) {
            // If not, prepend "C/O" to the input
            coName = pattern + (coName ? ` ${coName}` : "");
        }

        // Check if the input consists only of "C/O"
        if (coName.toLowerCase() === pattern.toLowerCase()) {
            // If so, set the input to empty
            coName = "";
        }

        dispatch({ type: UPDATE_CO_NAME, payload: coName, id });
    };
}

export function updateFloor(floor: string, id: string) {
    return { type: UPDATE_FLOOR, payload: floor, id }
}
export function updateHouseLetterFrom(houseletterFrom: string, id: string) {
    return { type: UPDATE_HOUSE_LETTER_FROM, payload: houseletterFrom, id }
}
export function updateHouseLetterTo(houseletterTo: string, id: string) {
    return { type: UPDATE_HOUSE_LETTER_TO, payload: houseletterTo, id }
}
export function updateHouseNumberFrom(houseNumberFrom: string, id: string) {
    return { type: UPDATE_HOUSE_NUMBER_FROM, payload: houseNumberFrom, id }
}
export function updateHouseNumberTo(houseNumberTo: string, id: string) {
    return { type: UPDATE_HOUSE_NUMBER_TO, payload: houseNumberTo, id }
}
export function updateIsForeignAddress(isForeignAddress: boolean, id: string) {
    return { type: UPDATE_IS_FOREIGN_ADDRESS, payload: isForeignAddress, id }
}
export function updateMunicipalityCode(municipalityCode: string, id: string) {
    return { type: UPDATE_MUNICIPALITY_CODE, payload: municipalityCode, id }
}
export function updatePostalDistrict(postalDistrict: string, id: string) {
    return { type: UPDATE_POSTAL_DISTRICT, payload: postalDistrict, id }
}
export function updatePostalCode(postalCode: string, id: string): (dispatch: Dispatch<any>, getState: () => InitState) => Promise<void> {
    return async (dispatch: Dispatch<any>) => {
        dispatch({ type: UPDATE_POSTAL_CODE, payload: postalCode, id })

        if (postalCode.length === 4) {
            // Find a matching postalcode
            const postalCodeObj = ((window as any).postalCodes as IPostalCodeVm[]).filter((x) => {
                return x.postalCode === postalCode
            })

            // Update postalDistrict if postalCodeObj is found
            postalCodeObj.length > 0 ?
                dispatch(updatePostalDistrict(postalCodeObj[0].city, id)) :
                dispatch(updatePostalDistrict("", id))
        }
    }
}
export function updatePostbox(postbox: string, id: string) {
    return { type: UPDATE_POSTBOX, payload: postbox, id }
}
export function updateSideDoor(sideDoor: string, id: string) {
    return { type: UPDATE_SIDE_DOOR, payload: sideDoor, id }
}
export function updateStreetName(streetName: string, id: string) {
    return { type: UPDATE_STREET_NAME, payload: streetName, id }
}
export function updateCountry(country: ICountryVm, id: string): (dispatch: Dispatch<any>, getState: () => InitState) => Promise<void> {
    return async (dispatch: Dispatch<any>, getState: () => InitState) => {
        dispatch(updateCountryName(country.countryName, id))
        dispatch(updateCountryCode(country.countryCodeAlpha2, id))
    }
}
export function replaceAddress(address: IAddressVm, id: string): (dispatch: Dispatch<any>, getState: () => InitState) => Promise<void> {
    return async (dispatch: Dispatch<any>, getState: () => InitState) => {
        dispatch(updateBuildingName(address.buildingName, id))
        dispatch(updateBuildingNumber(address.buildingNumber, id))
        dispatch(updateCityName(address.cityName, id))
        dispatch(updateCombinedStreetAddressLine(address.combinedStreetAddressLine, id))
        dispatch(updateCoName(address.coName, id))
        dispatch(updateFloor(address.floor, id))
        dispatch(updateHouseLetterFrom(address.houseLetterFrom, id))
        dispatch(updateHouseLetterTo(address.houseLetterTo, id))
        dispatch(updateHouseNumberFrom(address.houseNumberFrom, id))
        dispatch(updateHouseNumberTo(address.houseNumberTo, id))
        dispatch(updateIsForeignAddress(address.isForeignAddress, id))
        dispatch(updateMunicipalityCode(address.municipalityCode, id))
        dispatch(updatePostalCode(address.postalCode, id))
        dispatch(updatePostalDistrict(address.postalDistrict, id))
        dispatch(updatePostbox(address.postbox, id))
        dispatch(updateSideDoor(address.sideDoor, id))
        dispatch(updateStreetName(address.streetName, id))
        dispatch(updateCountryCode(address.countryCode, id))
        dispatch(updateCountryName(address.countryName, id))
    }
}
function updateCountryCode(countryCode: string, id: string) {
    return { type: UPDATE_COUNTRY_CODE, payload: countryCode, id }
}
function updateCountryName(countryName: string, id: string) {
    return { type: UPDATE_COUNTRY_NAME, payload: countryName, id }
}
